import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const DELIVERY_BADGE_CONFIG = {
    sent:      { label: 'Sent',      color: 'text.disabled' },
    delivered: { label: 'Delivered', color: 'success.light' },
    opened:    { label: 'Opened',    color: 'success.main' },
    read:      { label: 'Read',      color: 'success.main' },
    clicked:   { label: 'Clicked',   color: 'primary.main' },
};

export default function DeliveryBadge({ status, inline }) {
    if (!status) return null;
    const cfg = DELIVERY_BADGE_CONFIG[status.key] || DELIVERY_BADGE_CONFIG.sent;

    if (inline) {
        return (
            <Typography
                component="span"
                variant="caption"
                sx={{ fontSize: '0.65rem', color: cfg.color, lineHeight: 1, ml: 0.75, whiteSpace: 'nowrap' }}
            >
                ✓ {cfg.label}
            </Typography>
        );
    }

    return (
        <Typography
            variant="caption"
            sx={{ fontSize: '0.6rem', color: cfg.color, lineHeight: 1, pl: 0.25, mt: 0.25, display: 'block' }}
        >
            ✓ {cfg.label}
        </Typography>
    );
}

DeliveryBadge.propTypes = {
    status: PropTypes.shape({ key: PropTypes.string, priority: PropTypes.number }),
    inline: PropTypes.bool,
};

DeliveryBadge.defaultProps = {
    status: null,
    inline: false,
};
